(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/instructions-info.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/instructions-info.js');
"use strict";

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const NeedHelp = svs.tur.NeedHelp;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
setGlobal('svs.ticketsOrderHome.components.InstructionsInfo', _ref => {
  let _ref$showStepByStep = _ref.showStepByStep,
    showStepByStep = _ref$showStepByStep === void 0 ? true : _ref$showStepByStep;
  return React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 8,
    sm: 12
  }, showStepByStep && React.createElement(WidgetArea, {
    areaName: "stepByStepWidget"
  }), React.createElement(NeedHelp, null)));
});

 })(window);